import React, { useState } from "react";
import { Query, Mutation, ApolloConsumer } from "react-apollo";
import gql from "graphql-tag";
import UserForm from "../../components/UserForm";
import { useToast } from "@chakra-ui/react";
import { Redirect } from "react-router";

const EditUser = (props) => {
  const [tokenLink, setTokenLink] = useState("");
  const toast = useToast();

  const submitResponse = (data, error, cb) => {
    if (data && data.editUser && data.editUser.meta) {
      const { payload, message } = data.editUser.meta;

      if (payload.error) {
        cb({ success: false });
        toast({
          title:
            typeof payload.error === "string"
              ? payload.error
              : JSON.stringify(payload.error),
          status: message === "noFieldsUpdated" ? "warning" : "error",
          position: "bottom-right",
        });
      } else if (payload.response) {
        cb({ success: true });
        toast({
          title: payload.response,
          status: "success",
          position: "bottom-right",
        });
      } else {
        cb({ success: false });
        toast({
          title: "An error occurred while updating this user.",
          status: "error",
          position: "bottom-right",
        });
      }
    } else if (error) {
      console.log("EditUser.handleFormSubmit", error);
      toast({
        title: "An error occurred while updating this user.",
        status: "error",
        position: "bottom-right",
      });
    }
  };

  const generateToken = async (client) => {
    let selectText = tokenLink;
    if (tokenLink === "") {
      try {
        let response = await client.query({
          query: GET_TOKEN,
          fetchPolicy: "network-only",
          variables: { id: props.data.user.id },
        });
        if (response && response.data) {
          let host = "https://etr.plus";
          if (window.location.origin === "http://localhost:4040") {
            host = "http://localhost:4000";
          }
          let token = response.data.getAuthToken;
          selectText = host + "/reset-password?token=" + token;
          setTokenLink(selectText);
        }
      } catch (err) {
        console.log("Error fetching team user", err);
      }
    }
    let input = document.createElement("input");
    input.value = selectText;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
  };

  return (
    <div>
      <div className="page-header">
        <i className="fas fa-user-edit fa-lg"></i>
        <h3>Edit User (id: {props.data.user.id})</h3>
        <ApolloConsumer>
          {(client) => (
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => generateToken(client)}
            >
              Generate Password Reset Link
            </button>
          )}
        </ApolloConsumer>
        {tokenLink != "" ? " Copied" : ""}
      </div>
      <div>
        <UserForm
          user={props.data.user}
          viewer={props.data.viewer}
          userRoles={props.data.userRoles}
          mutate={props.editUser}
          submitResponse={submitResponse}
        />
      </div>
    </div>
  );
};

const GET_USER = gql`
  query GET_USER($id: String!) {
    viewer {
      id
      roles
      editableRoles
      specialPermissions {
        isAdmin
      }
    }
    userRoles {
      name
      group
      description
      displayName
    }
    user(id: $id) {
      id
      email
      name
      organization
      specialPermissions {
        isAdmin
        isPerformance
      }
      industry
      roles
      standing
      deviceLimit
      isActive
      standing
      disableDeviceCheck
      isFreeTrial
      freeTrialStartDate: freeTrialStartDateISO
      freeTrialEndDate
      excludeRespondents
    }
    routes: dashboardRoutes {
      id
      path
      displayName
      requirePermission
      chapters {
        id
        path
        displayName
      }
    }
  }
`;

const EDIT_USER = gql`
  mutation EDIT_USER(
    $id: String!
    $name: String!
    $email: String!
    $organization: String!
    $password: String
    $deviceLimit: Int
    $specialPermissions: specialPermissionsInput
    $roles: [String!]
    $isActive: Boolean
    $isFreeTrial: Boolean
    $freeTrialStartDate: String
    $freeTrialEndDate: String
    $disableDeviceCheck: Boolean
    $industry: Industry!
    $excludeRespondents: Boolean!
  ) {
    editUser(
      id: $id
      name: $name
      email: $email
      organization: $organization
      password: $password
      deviceLimit: $deviceLimit
      specialPermissions: $specialPermissions
      roles: $roles
      isActive: $isActive
      isFreeTrial: $isFreeTrial
      freeTrialStartDate: $freeTrialStartDate
      freeTrialEndDate: $freeTrialEndDate
      disableDeviceCheck: $disableDeviceCheck
      industry: $industry
      excludeRespondents: $excludeRespondents
    ) {
      meta {
        message
        payload
      }
    }
  }
`;

const GET_TOKEN = gql`
  query GET_TOKEN($id: String!) {
    getAuthToken(id: $id)
  }
`;

const EditUserWithData = (props) => (
  <Query
    query={GET_USER}
    variables={props.match.params}
    fetchPolicy="network-only"
  >
    {({ loading, error, data }) => {
      let noData = !data || !data.user || !data.roles || !data.dashboardRoutes;

      if (loading && noData) return <div>Loading...</div>;

      if (error) return <div>Error: {error}</div>;

      if (!loading && data && !data.user) return <Redirect to="/" />;

      return (
        <Mutation mutation={EDIT_USER}>
          {(mutate) => (
            <EditUser
              {...props}
              data={data}
              loading={loading}
              editUser={mutate}
            />
          )}
        </Mutation>
      );
    }}
  </Query>
);

export default EditUserWithData;
